import React, { HTMLProps } from 'react';
import classnames from 'classnames';
import { Column } from './column';
import styles from './column.module.scss';
import Element from '../../element';

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    children: React.ReactNode;
    breakpoint?: string;
    gapless?: boolean;
    multiline?: boolean;
    centered?: boolean;
    vCentered?: boolean;
    variableGap?: any;
}

function Columns(props: IProps) {
    const {
        children,
        className,
        breakpoint,
        gapless,
        multiline = true,
        centered,
        vCentered,
        variableGap = {},
        ...rest
    } = props;

    return (
        <Element
            {...rest}
            className={classnames(className, styles['columns'], {
                [styles[`is-${breakpoint}`]]: breakpoint,
                [styles['is-gapless']]: gapless,
                [styles['is-multiline']]: multiline,
                [styles['is-centered']]: centered,
                [styles['is-vcentered']]: vCentered,
                [styles['is-variable']]: Object.keys(variableGap).length > 0,
                ...(variableGap
                    ? {
                          [styles[`is-${variableGap.touch}-touch`]]:
                              variableGap.touch,
                          [styles[`is-${variableGap.mobile}-mobile`]]:
                              variableGap.mobile,
                          [styles[`is-${variableGap.tablet}-tablet`]]:
                              variableGap.tablet,
                          [styles[`is-${variableGap.desktop}-desktop`]]:
                              variableGap.desktop,
                          [styles[`is-${variableGap.widescreen}-widescreen`]]:
                              variableGap.widescreen,
                          [styles[`is-${variableGap.fullhd}-fullhd`]]:
                              variableGap.fullhd,
                      }
                    : {}),
            })}
        >
            {children}
        </Element>
    );
}

Columns.Column = Column;

export default Columns;
